import React, { useEffect, useState } from 'react';
import './Review.css'; // Keep your styles

function ReviewPage() {
  const [textReviews, setTextReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Fetch feedback on component mount
  useEffect(() => {
    const fetchFeedbacks = async () => {
      try {
        const response = await fetch('https://swarna-herbal-backend.onrender.com/api/feedback/get-feedbacks/1');
        if (!response.ok) {
          throw new Error('Failed to fetch reviews');
        }
        const data = await response.json();
        setTextReviews(data);
      } catch (err) {
        setError(err.message || 'Something went wrong');
      } finally {
        setLoading(false);
      }
    };

    fetchFeedbacks();
  }, []);

  return (
    <div className="review-page">
      <h1 style={{ textAlign: "center" }}>Customer Reviews</h1>

      {loading && <p style={{ textAlign: 'center' }}>Loading reviews...</p>}
      {error && <p style={{ textAlign: 'center', color: 'red' }}>{error}</p>}

      <div className="review-gallery">
        {textReviews.map((review) => (
          <div key={review._id} className="review-item">
            <p className="review-text">"{review.feedback}"</p>
            <p className="review-author">– {review.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ReviewPage;
